import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield } from 'lucide-react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
export function Pricing() {
  const handleCheckout = () => window.open('https://checkout.librofy.online/cart/53040448274795:1', '_blank');
  const included = ['Curso completo: los 5 módulos', 'Todos los bonos exclusivos', 'Acceso inmediato y de por vida', 'Actualizaciones futuras incluidas', 'Garantía total de 7 días'];
  return <section id="pricing" className="bg-white py-24" data-id="element-137">
      <div className="container mx-auto px-4" data-id="element-138">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-139">
          <FadeIn data-id="element-140">
            <div className="inline-block bg-red-100 text-red-600 font-bold px-4 py-1.5 rounded-full text-sm mb-6 uppercase tracking-wider animate-pulse" data-id="element-141">
              PROMOCIÓN POR TIEMPO LIMITADO
            </div>

            <div className="max-w-md mx-auto mb-10" data-id="element-142">
              <div className="flex justify-between text-sm font-bold text-navy-900 mb-2" data-id="element-143">
                <span data-id="element-144">Cupos disponibles agotándose</span>
                <span data-id="element-145">80% tomados</span>
              </div>
              <div className="h-3 bg-gray-200 rounded-full overflow-hidden" data-id="element-146">
                <motion.div initial={{
                width: 0
              }} whileInView={{
                width: '80%'
              }} transition={{
                duration: 1.5,
                ease: 'easeOut'
              }} className="h-full bg-red-500 rounded-full" data-id="element-147" />
              </div>
              <p className="text-sm text-gray-500 mt-2" data-id="element-148">
                Últimos cupos al precio promocional. Luego vuelve al valor
                normal.
              </p>
            </div>

            <h2 className="text-3xl md:text-5xl font-heading font-bold text-navy-950 mb-6" data-id="element-149">
              Tu acceso completo al sistema
            </h2>
          </FadeIn>
        </div>

        <FadeIn delay={0.2} className="max-w-xl mx-auto mb-12" data-id="element-150">
          <div className="relative bg-navy-900 rounded-3xl p-8 sm:p-10 border-2 border-gold-500 text-center shadow-2xl" data-id="element-151">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gold-500 text-navy-950 font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap" data-id="element-152">
              ⭐ OFERTA EXCLUSIVA
            </div>

            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2 mt-2" data-id="element-153">
              CAPITÁN INTERNACIONAL
            </h3>
            <p className="text-gray-300 mb-8" data-id="element-154">
              Curso completo + todos los bonos
            </p>

            <div className="mb-8" data-id="element-155">
              <span className="text-gray-400 line-through text-2xl block mb-1" data-id="element-156">
                $89.900
              </span>
              <span className="text-5xl sm:text-6xl font-bold text-white" data-id="element-157">
                $19.900
              </span>
              <p className="text-gold-400 font-medium mt-2 text-sm" data-id="element-158">
                Pago único · Acceso de por vida
              </p>
            </div>

            <ul className="space-y-3 text-left mb-8 max-w-sm mx-auto" data-id="element-159">
              {included.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-200" data-id="element-160">
                  <Check className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-161" />
                  <span data-id="element-162">{item}</span>
                </li>)}
            </ul>

            <Button size="xl" onClick={handleCheckout} className="w-full shadow-gold-500/30 text-base sm:text-lg" data-id="element-163">
              SÍ, QUIERO MI ACCESO →
            </Button>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="text-center max-w-2xl mx-auto" data-id="element-164">
          <div className="flex justify-center gap-6 text-sm text-gray-600 mb-6 font-medium flex-wrap" data-id="element-165">
            <span data-id="element-166">Pago seguro</span>
            <span data-id="element-167">•</span>
            <span data-id="element-168">Acceso en minutos</span>
            <span data-id="element-169">•</span>
            <span data-id="element-170">Garantía 7 días</span>
          </div>

          <div className="bg-green-50 border border-green-200 rounded-xl p-4 flex items-start gap-3 text-left" data-id="element-171">
            <Shield className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-172" />
            <p className="text-green-800 text-sm" data-id="element-173">
              <strong data-id="element-174">Garantía total:</strong> Si no te aporta valor, te
              devolvemos el 100% de tu dinero.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}